import { Injectable } from '@angular/core';

@Injectable()
export class ApiService {
  title = 'Angular 2';
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/api.service.ts